import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class BookingItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsOptional()
  @IsString()
  @Expose()
  creationDate!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  recordLocator!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  firstNumber!: string | null;
  @IsString()
  @Expose()
  passengerName!: string;
  @IsNumber()
  @Expose()
  grandTotal!: number;
  @IsOptional()
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  serviceTypeCode!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  status!: number;
}

export class BookingItemsResponse extends GenericTableResponse<BookingItem> {
  @Type(() => BookingItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BookingsItem>;
}
